export default "__VITE_ASSET__CnkqY$8p__"